import type { TFileWithMeta } from '@components/Files/UploadProvider/types/TFileWithMeta';

export type TPendingMediaAnalysis = { fileId: string; mediaId: string };

export const collectPendingMediaAnalyses = (files: TFileWithMeta[]): TPendingMediaAnalysis[] =>
  files.flatMap((file) => {
    const mediaId = String(file.meta.extra?.mediaId ?? '');
    const isPending =
      file.meta.status !== 'removed' && mediaId !== '' && file.meta.extra?.analysisStatus === 'progress';
    return isPending ? [{ fileId: file.meta.id, mediaId }] : [];
  });
